import { envVar } from '~/env'

export function privateDocumentPath(organizationId: string, documentId: string) {
  return `organizations/${organizationId}/private/documents/${documentId}`
}

export function resolvePublicStorageURL(path: string) {
  if (path.startsWith('https://') || path.startsWith('http://')) {
    return path
  }

  const storagePath = path.startsWith('storage://') ? path.slice('storage://'.length) : path
  return `${envVar('NEXT_PUBLIC_STORAGE_ENDPOINT')}/${storagePath}`
}
